import React from "react";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <>
      <div>
        <img
          className="w-full block h-[550px] object-cover"
          src="https://assets.nflxext.com/ffe/siteui/vlv3/c38a2d52-138e-48a3-ab68-36787ece46b3/eeb03fc9-99c6-438e-824d-32917ce55783/IN-en-20240101-popsignuptwoweeks-perspective_alpha_website_large.jpg"
          alt=""
        />
        <div className="bg-black/70 fixed top-0 left-0 w-full h-full" />
      </div>
      <div className=" absolute top-[30%] left-[25%] p-4 md:p-8">
        <h1 className=" font-nsans-bold text-3xl md:text-5xl my-2">ERR 404</h1>
        <h1 className=" font-nsans-light text-2xl md:text-xl my-2">
          Oops! You've discovered a missing page in our secret treasure map.
          <br />
          Captain, set sail back to the{" "}
          <a className="text-red-600" href="/">
            home port
          </a>{" "}
          to find other hidden gems!
        </h1>
      </div>
    </>
  );
};

export default Error;

<Link to="/">
  <button className="bg-red-600 hover:bg-red-800 text-white font-bold py-2 px-4 rounded">
    Go Back
  </button>
</Link>;
